// import React from 'react';
// import { Container, Typography, Button, Box, Grid } from '@mui/material';
// import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
// const CompletionScreen = () => {
//   return (
//     <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
//       <Box display="flex" justifyContent="center">
//         <EmojiEventsIcon style={{ fontSize: 60, color: '#FFD700' }} />
//       </Box>
//       <Typography  variant="h4" gutterBottom style={{ marginTop: '20px' }}>
//         أسطـــووورة
//       </Typography>
//       <Typography variant="body1" gutterBottom>
//         لقد أنهيت لتوك درسك الأول!
//       </Typography>
//       <Grid container spacing={3} style={{ marginTop: '20px' }}>
//         <Grid item xs={4}>
//           <Typography variant="subtitle1">88%</Typography>
//           <Typography variant="caption">جيد</Typography>
//         </Grid>
//         <Grid item xs={4}>
//           <Typography variant="subtitle1">2:20</Typography>
//           <Typography variant="caption">خاطف</Typography>
//         </Grid>
//         <Grid item xs={4}>
//           <Typography variant="subtitle1">24 XP</Typography>
//           <Typography variant="caption">إجمالي نقاط XP</Typography>
//         </Grid>
//       </Grid>
//       <Button variant="contained" color="primary" style={{ marginTop: '20px' }}>
//         مارس الآن وحاول تنهي هذا التحدي
//       </Button>
//     </Container>
//   );
// };

// export default CompletionScreen;

import React from 'react';
import { Container, Typography, Button } from '@mui/material';

const CompletionScreen = ({ word, onNext }) => {
  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        أحسنت! لقد أكملت تعلم كلمة "{word}"
      </Typography>
      <Button variant="contained" color="primary" style={{ marginTop: '20px' }} onClick={onNext}>
        استمر للكلمة التالية
      </Button>
    </Container>
  );
};

export default CompletionScreen;

